import { render, staticRenderFns } from "./AscReleaseNotesTemplate.vue?vue&type=template&id=51791bd3&"
import script from "./AscReleaseNotesTemplate.vue?vue&type=script&lang=js&"
export * from "./AscReleaseNotesTemplate.vue?vue&type=script&lang=js&"
import style0 from "./AscReleaseNotesTemplate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports